import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NbAccordionModule, NbDatepickerModule, NbIconModule, NbInputModule, NbLayoutModule, NbMenuModule, NbProgressBarModule, NbSidebarModule, NbStepperModule, NbThemeModule, NbToastrModule } from '@nebular/theme';
import { AgGridModule } from 'ag-grid-angular';
import {  CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CollapsibleComponent } from './collapsible/collapsible.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'; // Import this
import { SharedModule } from './Shared-Module/shared.module';
import { ToastrModule } from 'ngx-toastr';
import { AuthInterceptor } from 'src/Core/auth.interceptor';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  declarations: [
    AppComponent,
    CollapsibleComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    AgGridModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    HttpClientModule,
   
    // =======Updations=====
    NbThemeModule.forRoot({ name: 'default' }),  // Make sure this matches the theme you imported
    NbProgressBarModule,
    NbStepperModule,
    NbAccordionModule,  
    NbLayoutModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbIconModule,
    SharedModule,
    NbDatepickerModule.forRoot(),  // This ensures the datepicker is properly initialized
    NbInputModule,
    NgSelectModule,  
    NbMenuModule, NbSidebarModule 
  
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }

  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA], 
})
export class AppModule { }
